import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SOConsolidationRunLineModel } from "../../../../../../models/aggregates/so-consolidation/index";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
} from "../../shared";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SOConsolidationRunLineService extends BaseApiTemplateService<SOConsolidationRunLineModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/run-lines/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/run-lines/backoffice-ep";
    this.httpClient = http;
  }

  consolidateOrders(
    dtoOject: any,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    const apiUrl =
      visa.api_domain_url +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/run-lines/processors/consolidate-internal-sales-invoices/backoffice-ep";
    return this.httpClient.post<ApiResponseModel<any>>(
      apiUrl,
      dtoOject,
      this.getHttpHeader(visa)
    );
  }
}
